module.exports = __webpack_public_path__ + "img/symbol_3.36862238.png";